/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：137
 */

module.exports = {
  container: "StyleDialog_container__3z84w",
  title: "StyleDialog_title__3VmNA",
  content: "StyleDialog_content__2bNNh",
  actionBar: "StyleDialog_actionBar__2DqOp",
  actionList: "StyleDialog_actionList__2nWjt",
  addAction: "StyleDialog_addAction__3xNcb",
  addActionIcon: "StyleDialog_addActionIcon__3lo7S",
  actionItem: "StyleDialog_actionItem__1WApy",
  selected: "StyleDialog_selected__1hk9S",
  dragging: "StyleDialog_dragging__37h_z",
  deleteButton: "StyleDialog_deleteButton__2jYqg",
  actionImg: "StyleDialog_actionImg__2TN4n",
  emptyImg: "StyleDialog_emptyImg__1nM--",
  actionName: "StyleDialog_actionName__3zYuT",
  nameInput: "StyleDialog_nameInput__1YbpO",
  nameText: "StyleDialog_nameText__3QCKF",
  deleteContainer: "StyleDialog_deleteContainer__3KCc2",
  copyButton: "StyleDialog_copyButton__2MEQC",
  main: "StyleDialog_main__1cbgL",
  styleListContainer: "StyleDialog_styleListContainer__1HsnT",
  styleList: "StyleDialog_styleList__JRTJO",
  leftScrollable: "StyleDialog_leftScrollable__S69d7",
  rightScrollable: "StyleDialog_rightScrollable__1xpzY",
  styleItem: "StyleDialog_styleItem__VRi_0",
  image: "StyleDialog_image__r3yjh",
  seq: "StyleDialog_seq__2_tAH",
  deleteStyle: "StyleDialog_deleteStyle__2bi_n",
  copyStyle: "StyleDialog_copyStyle__3TDUj",
  hovering: "StyleDialog_hovering__1-ycR",
  playerContainer: "StyleDialog_playerContainer__1AHnn",
  playButton: "StyleDialog_playButton__1I5MN",
  disabled: "StyleDialog_disabled__ydIn8",
  intervalContainer: "StyleDialog_intervalContainer__2Xy-M",
  dropdown: "StyleDialog_dropdown__tEDa-",
  tips: "StyleDialog_tips__1d-W7",
  addStyleContainer: "StyleDialog_addStyleContainer__1VX-Z",
  btnIcon: "StyleDialog_btnIcon__11uQU",
  addStyle: "StyleDialog_addStyle__2zNzg",
  addIcon: "StyleDialog_addIcon__2nNxl",
  imageEditorContainer: "StyleDialog_imageEditorContainer__kCmhk",
  imageEditor: "StyleDialog_imageEditor__1Reuz",
  imageContainer: "StyleDialog_imageContainer__3k30Z",
  imageDragContainer: "StyleDialog_imageDragContainer__wdQoY",
  ctrlBtnBar: "StyleDialog_ctrlBtnBar__3xEWp",
  checkbox: "StyleDialog_checkbox__2ljwE",
  footer: "StyleDialog_footer__2M9OC"
}
